import React from "react";
import App from "./components/App/App";
import * as serviceWorker from "./serviceWorker";
import { HashRouter } from "react-router-dom";
import { render } from "react-snapshot";

import "./index.scss";

render(
  <HashRouter>
    <App />
  </HashRouter>,
  document.getElementById("root")
);

serviceWorker.unregister();
